export const API_PENDING = 'API_PENDING'
export const API_FAILURE = 'API_FAILURE'
export const API_SUCCESS = 'API_SUCCESS'

export const RESET_INITIAL_STATE = 'RESET_INITIAL_STATE'

export const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR'
export const UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY'
